import React, { useCallback } from 'react';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import styles from '../../CoverEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SliderProps {
  /** The name of the value for a screen reader. */
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  /** The value as the row shows it ("570", "−2%"). */
  display: string;
  disabled?: boolean;
  onChange: (value: number) => void;
}

/** A slider row of the inspector (design cover-editor b1): the track and the value at its right. */
const SliderComponent: React.FC<SliderProps> = ({ label, value, min, max, step = 1, display, disabled, onChange }) => {
  const change = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => onChange(Number(event.target.value)),
    [onChange]
  );
  return (
    <span className={styles.sliderRow}>
      <input
        className={styles.range}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        aria-label={label}
        onChange={change}
      />
      <em className={styles.sliderValue}>{display}</em>
    </span>
  );
};

export const Slider = TypedMemo(SliderComponent);
